import { render, staticRenderFns } from "./OrthoKneeDistance.vue?vue&type=template&id=0f902d84&scoped=true"
import script from "./OrthoKneeDistance.vue?vue&type=script&lang=js"
export * from "./OrthoKneeDistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f902d84",
  null
  
)

export default component.exports